// Traductions anglais — clé = phrase française
const dict = {
  ", à {m} chacun paie {n}": ", with {m} each pays {n}",
  "Accueil": "Home",
  "Activer le mode prof ? Votre profil apparaîtra dans « Nos professeurs » et vous pourrez créer des cours. Vous pourrez toujours revenir en mode élève.": "Switch to teacher mode? Your profile will appear in “Our teachers” and you'll be able to create classes. You can always switch back to student mode.",
  "Administrateur": "Administrator",
  "Administration": "Admin",
  "Annuler": "Cancel",
  "Apprends ensemble": "Learn together",
  "Après le cours, vous recevez {n} ({total} − 10 % de commission Tatie Soso), quel que soit le nombre d'inscrits.": "After the class you receive {n} ({total} − 10% Tatie Soso commission), whatever the number of students.",
  "Après le cours, vous recevrez": "After the class you'll receive",
  "Arts": "Arts",
  "Attention : en version gratuite, Meet coupe à 60 min et Zoom à 40 min.": "Note: on the free plans, Meet cuts off at 60 min and Zoom at 40 min.",
  "Aucun compte trouvé avec ce compte Google. Créez d'abord un compte.": "No account found for this Google account. Please create an account first.",
  "Aucun cours prévu pour l'instant.": "No classes scheduled yet.",
  "Aucun cours trouvé pour l'instant.": "No classes found for now.",
  "Aucun professeur trouvé.": "No teacher found.",
  "Aucun utilisateur trouvé avec cet email.": "No user found with this email.",
  "Aucun élève inscrit pour l'instant.": "No students enrolled yet.",
  "Aucune description.": "No description.",
  "Autre montant": "Other amount",
  "Avis": "Reviews",
  "Bonjour {name} !": "Hello {name}!",
  "Bruxelles, Belgique": "Brussels, Belgium",
  "Ce cours a déjà été payé au professeur : remboursement impossible.": "This class has already been paid to the teacher: refund not possible.",
  "Ce cours a déjà été payé.": "This class has already been paid.",
  "Ce cours est complet.": "This class is full.",
  "Ce cours est déjà terminé.": "This class has already ended.",
  "Ce cours est terminé.": "This class has ended.",
  "Ce domaine n'est pas autorisé dans Firebase (Authentication → Settings → Authorized domains).": "This domain is not authorised in Firebase (Authentication → Settings → Authorized domains).",
  "Ce que les élèves vont apprendre...": "What students will learn...",
  "Cette heure est déjà passée.": "This time has already passed.",
  "Changer de mode": "Switch mode",
  "Chaque nouvel inscrit fait baisser ta part (jusqu'à {min}) : tu es remboursé·e de la différence.": "Each new sign-up lowers your share (down to {min}): you get the difference back.",
  "Chargement des cours...": "Loading classes...",
  "Chargement...": "Loading...",
  "Choisissez une date.": "Choose a date.",
  "Choisissez une heure de début.": "Choose a start time.",
  "Cliquez pour entrer": "Click to enter",
  "Collez le lien de votre réunion (Meet, Zoom…).": "Paste your meeting link (Meet, Zoom…).",
  "Comment ça marche ?": "How does it work?",
  "Complet": "Full",
  "Confirmer ({n} élève(s) remboursé(s))": "Confirm ({n} student(s) refunded)",
  "Confirmer l'inscription": "Confirm sign-up",
  "Connexion": "Log in",
  "Connexion / Inscription": "Log in / Sign up",
  "Connexion annulée.": "Login cancelled.",
  "Continuer avec Google": "Continue with Google",
  "Copier le lien de la salle": "Copy room link",
  "Cours introuvable.": "Class not found.",
  "Cours à venir": "Upcoming classes",
  "Création...": "Creating...",
  "Créer le cours": "Create class",
  "Créer mon compte avec Google": "Create my account with Google",
  "Créer un compte": "Create an account",
  "Créer un cours": "Create a class",
  "Créée automatiquement, gratuite, sans limite de durée. Rien à installer.": "Created automatically, free, no time limit. Nothing to install.",
  "Date": "Date",
  "Date de naissance": "Date of birth",
  "Des cours en petits groupes pour apprendre ensemble. Plus on est nombreux, moins c'est cher !": "Small-group classes to learn together. The more of us, the cheaper it gets!",
  "Des cours en petits groupes — plus on est nombreux, moins c'est cher.": "Small-group classes — the more of us, the cheaper it gets.",
  "Des passionné·es de tous horizons, prêt·es à partager leur savoir avec toi.": "Passionate people from all walks of life, ready to share their knowledge with you.",
  "Des passionné·es prêt·es à partager leur savoir": "Passionate people ready to share what they know",
  "Description": "Description",
  "Description / Bio": "Description / Bio",
  "Document introuvable.": "Document not found.",
  "Droit": "Law",
  "Durée": "Duration",
  "Déconnexion": "Log out",
  "Déposer des fonds": "Add funds",
  "Déposer {n}€ via PayPal": "Deposit €{n} via PayPal",
  "Email du destinataire": "Recipient's email",
  "Email ou montant invalide.": "Invalid email or amount.",
  "En continuant, vous acceptez les": "By continuing, you accept the",
  "Enregistrement...": "Saving...",
  "Enregistrer": "Save",
  "Ex. Fractions pour les nuls": "E.g. Fractions for beginners",
  "Ex. Mathématiques": "E.g. Maths",
  "Fermer": "Close",
  "Fermer le menu": "Close menu",
  "Grâce à Tatie Soso, j'ai rattrapé mes lacunes en maths en seulement 3 séances. Je recommande !": "Thanks to Tatie Soso, I caught up in maths in just 3 sessions. Highly recommended!",
  "Géographie": "Geography",
  "Gérez vos pièces d'or Tatie Soso": "Manage your Tatie Soso gold coins",
  "Heure de début": "Start time",
  "Il n'est pas nécessaire d'être maître d'école pour donner des cours particuliers. Tatie Soso encourage tout un chacun à offrir de son temps et de sa personne pour un partage unique de connaissances. Les seuls maîtres mots sont bienveillance et apprentissage.": "You don't need to be a schoolteacher to give private lessons. Tatie Soso encourages everyone to give a little of their time and themselves for a unique sharing of knowledge. The only watchwords are kindness and learning.",
  "Ils nous font confiance": "They trust us",
  "Impossible d'envoyer la photo. Réessayez plus tard.": "Couldn't upload the photo. Please try again later.",
  "Impossible de charger vos cours.": "Couldn't load your classes.",
  "Informatique": "Computing",
  "Inscris-toi": "Sign up",
  "J'ai trouvé un cours de droit en 24h. Tatie Soso c'est magique !": "I found a law class within 24 hours. Tatie Soso is magic!",
  "Je suis": "I am",
  "Je suis professeur·e": "I'm a teacher",
  "Je suis étudiant·e": "I'm a student",
  "Je veux…": "I want to…",
  "L'image ne doit pas dépasser 5 Mo.": "The image must not exceed 5 MB.",
  "La création du cours a échoué. Vérifiez votre connexion et réessayez.": "Creating the class failed. Check your connection and try again.",
  "La date doit être aujourd'hui ou dans le futur.": "The date must be today or later.",
  "La description doit faire au moins 10 caractères.": "The description must be at least 10 characters.",
  "La fenêtre de connexion a été bloquée par le navigateur. Autorisez les pop-ups puis réessayez.": "The login window was blocked by the browser. Allow pop-ups and try again.",
  "La salle ouvrira {n} min avant le début": "The room opens {n} min before the start",
  "La suppression du cours a échoué.": "Deleting the class failed.",
  "Langue": "Language",
  "Langues": "Languages",
  "Le bouton pour rejoindre la visio apparaîtra dans « Mes cours » 15 minutes avant le début.": "The button to join the video call will appear in “My classes” 15 minutes before the start.",
  "Le concept de partager le coût entre élèves est vraiment innovant. Bravo !": "Splitting the cost between students is a really innovative idea. Well done!",
  "Le fichier doit être une image.": "The file must be an image.",
  "Le lien de session sera communiqué par le professeur.": "The session link will be shared by the teacher.",
  "Le lien doit commencer par https:// et ne pas contenir d'espace.": "The link must start with https:// and contain no spaces.",
  "Le montant doit être compris entre 1 et 1000 €.": "The amount must be between €1 and €1000.",
  "Le nom du cours doit faire au moins 4 caractères.": "The class name must be at least 4 characters.",
  "Le nombre d'élèves doit être un entier ≥ 1.": "The number of students must be a whole number ≥ 1.",
  "Le paiement sera disponible à la fin du cours.": "Payment will be available when the class ends.",
  "Le prix doit être d'au moins 1 pièce.": "The price must be at least 1 coin.",
  "Le prix est partagé entre les inscrits : si quelqu'un te rejoint, ta part passe à {next} (jusqu'à {min} si le cours est complet) et tu es remboursé·e automatiquement.": "The price is shared between everyone enrolled: if someone joins you, your share drops to {next} (down to {min} if the class is full) and you're refunded automatically.",
  "Le sujet doit faire au moins 3 caractères.": "The subject must be at least 3 characters.",
  "Les avis des élèves apparaîtront ici prochainement.": "Student reviews will appear here soon.",
  "Les cours que j'ai rejoints": "Classes I've joined",
  "Les cours que je donne": "Classes I teach",
  "Les matières": "Subjects",
  "Lien copié !": "Link copied!",
  "Lien du professeur": "Teacher's link",
  "Mathématiques": "Maths",
  "Mes cours": "My classes",
  "Mes cours (prof)": "My classes (teacher)",
  "Mode prof": "Teacher mode",
  "Mode élève": "Student mode",
  "Modifier le profil": "Edit profile",
  "Modifier mon profil": "Edit my profile",
  "Mon Portefeuille": "My Wallet",
  "Mon compte": "My account",
  "Mon portefeuille": "My wallet",
  "Mon propre lien (Google Meet, Zoom…)": "My own link (Google Meet, Zoom…)",
  "Montant (pièces)": "Amount (coins)",
  "Montant (€)": "Amount (€)",
  "Montant invalide (entre 1 et 1000 €).": "Invalid amount (between €1 and €1000).",
  "Musique": "Music",
  "Navigation": "Navigation",
  "Navigation principale": "Main navigation",
  "Nom": "Last name",
  "Nom du cours": "Class name",
  "Nos Professeurs": "Our Teachers",
  "Nos professeurs": "Our teachers",
  "Nouveau cours": "New class",
  "Oui, devenir prof": "Yes, become a teacher",
  "Ouvrir le menu": "Open menu",
  "Où nous trouver": "Where to find us",
  "Où tu veux,": "Wherever you like,",
  "Parce que l'éducation ne se limite pas à l'amélioration des résultats scolaires, Tatie Soso a pour vocation d'éveiller la curiosité des jeunes esprits. Trouve un cours adapté à tes besoins, rejoins une classe et apprends à ton rythme.": "Because education is about more than better grades, Tatie Soso sets out to spark curiosity in young minds. Find a class that suits your needs, join a group and learn at your own pace.",
  "Parcours les cours disponibles ou contacte un professeur pour en créer un sur mesure.": "Browse the available classes or contact a teacher to create one tailored to you.",
  "Participe au cours en ligne ou en présentiel, interagis avec ton professeur et tes camarades.": "Take part online or in person, and interact with your teacher and classmates.",
  "Passer l'intro": "Skip intro",
  "Passionné·e par le partage des connaissances, ce professeur est là pour t'aider à progresser.": "Passionate about sharing knowledge, this teacher is here to help you progress.",
  "Payé : {n}": "Paid: {n}",
  "Places": "Spots",
  "Portefeuille": "Wallet",
  "Prix du cours": "Class price",
  "Prix du cours (pièces)": "Class price (coins)",
  "Prix partagé entre les inscrits : un élève seul paie {n}": "Price shared between students: a single student pays {n}",
  "Prix {n}": "Price {n}",
  "Prix {price} · tu payes {mine}": "Price {price} · you pay {mine}",
  "Prof": "Teacher",
  "Professeur": "Teacher",
  "Professeur Tatie Soso": "Tatie Soso teacher",
  "Professeur introuvable.": "Teacher not found.",
  "Professeur passionné·e par le partage des connaissances.": "A teacher passionate about sharing knowledge.",
  "Professeurs": "Teachers",
  "Profil mis à jour": "Profile updated",
  "Profil utilisateur introuvable.": "User profile not found.",
  "Prénom": "First name",
  "Que la magie opère...": "Let the magic happen...",
  "Quelques mots sur toi...": "A few words about you...",
  "Recevoir mes pièces": "Collect my coins",
  "Recharger mon portefeuille": "Top up my wallet",
  "Rechercher un cours": "Search for a class",
  "Rechercher un cours ou un professeur": "Search for a class or a teacher",
  "Rechercher un cours, un prof…": "Search a class, a teacher…",
  "Rechercher un cours...": "Search for a class...",
  "Rechercher un professeur...": "Search for a teacher...",
  "Rejoindre": "Join",
  "Rejoindre l'équipe →": "Join the team →",
  "Rejoindre la magie ✨": "Join the magic ✨",
  "Rejoindre le cours": "Join the class",
  "Rejoins la classe. Le prix est partagé entre tous les élèves inscrits — plus on est, moins c'est cher.": "Join the class. The price is shared between all enrolled students — the more of us, the cheaper it gets.",
  "Retour": "Back",
  "Reviens bientôt ou contacte un professeur !": "Come back soon or contact a teacher!",
  "Salle Tatie Soso (Jitsi)": "Tatie Soso room (Jitsi)",
  "Salle Tatie Soso (Jitsi) — recommandé": "Tatie Soso room (Jitsi) — recommended",
  "Sciences": "Science",
  "Se connecter pour s'inscrire": "Log in to sign up",
  "Seul le professeur du cours peut être payé.": "Only the class's teacher can be paid.",
  "Solde actuel": "Current balance",
  "Solde insuffisant : il vous faut {need} (vous avez {have}).": "Insufficient balance: you need {need} (you have {have}).",
  "Solde insuffisant.": "Insufficient balance.",
  "Sujet": "Subject",
  "Supprimer le cours": "Delete class",
  "Ta part : {n}": "Your share: {n}",
  "Tatie Soso — accueil": "Tatie Soso — home",
  "Tester ma salle": "Test my room",
  "Ton solde : {n}": "Your balance: {n}",
  "Tous droits réservés": "All rights reserved",
  "Transférer": "Transfer",
  "Transférer des pièces": "Transfer coins",
  "Trouve un cours": "Find a class",
  "Tu payes": "You pay",
  "Tu payes maintenant": "You pay now",
  "Une erreur est survenue. Veuillez réessayer.": "Something went wrong. Please try again.",
  "Une plateforme intuitive et des professeurs bienveillants. Mes enfants adorent !": "An intuitive platform and kind teachers. My kids love it!",
  "Valeur Gold Coin": "Gold Coin value",
  "Versement...": "Paying out...",
  "Via PayPal — 1 € = 1 pièce": "Via PayPal — €1 = 1 coin",
  "Visio": "Video",
  "Visio via {p}": "Video via {p}",
  "Visioconférence": "Video call",
  "Voir le profil →": "View profile →",
  "Voir les cours": "See the classes",
  "Voir les cours à venir →": "See upcoming classes →",
  "Voir les cours →": "See the classes →",
  "Voir tous les professeurs": "See all teachers",
  "Vous devez être connecté.": "You need to be logged in.",
  "Vous n'avez encore créé aucun cours.": "You haven't created any classes yet.",
  "Vous n'êtes inscrit·e à aucun cours pour l'instant.": "You're not enrolled in any classes yet.",
  "Vous ne pouvez pas vous inscrire à votre propre cours.": "You can't sign up for your own class.",
  "Vous ne pouvez pas vous transférer des pièces à vous-même.": "You can't transfer coins to yourself.",
  "Vous pouvez suivre des cours et en donner. Changez de mode quand vous voulez.": "You can take classes and teach them. Switch mode whenever you like.",
  "Vous êtes aussi inscrit·e à {n} cours — passez en mode élève pour les voir.": "You're also enrolled in {n} class(es) — switch to student mode to see them.",
  "Vous êtes déjà inscrit à ce cours.": "You're already enrolled in this class.",
  "Vous êtes élève. Passez en mode prof pour proposer vos propres cours.": "You're a student. Switch to teacher mode to offer your own classes.",
  "arrivez en premier : Jitsi vous demandera de vous connecter (Google) pour ouvrir la salle": "arrive first: Jitsi will ask you to log in (Google) to open the room",
  "commission Tatie Soso : {n}": "Tatie Soso commission: {n}",
  "conditions d'utilisation": "terms of use",
  "de Tatie Soso.": "of Tatie Soso.",
  "exemple@email.com": "example@email.com",
  "https://meet.google.com/... ou https://zoom.us/j/...": "https://meet.google.com/... or https://zoom.us/j/...",
  "lien du prof": "teacher's link",
  "mais ensemble": "but together",
  "mise à jour en temps réel": "updated in real time",
  "profil": "profile",
  "quand tu veux,": "whenever you like,",
  "rechargez votre portefeuille pour vous inscrire.": "top up your wallet to sign up.",
  "voir mon compte": "view my account",
  "{n} ajoutées à votre portefeuille !": "{n} added to your wallet!",
  "{n} inscrits": "{n} enrolled",
  "{n} payées par les élèves − 10 % de commission": "{n} paid by students − 10% commission",
  "{n} pièces ajoutées à votre solde.": "{n} coins added to your balance.",
  "{n} pièces transférées à {email}.": "{n} coins transferred to {email}.",
  "{n} place restante": "{n} spot left",
  "{n} places restantes": "{n} spots left",
  "Le paiement n'a pas pu être enregistré. Contactez-nous.": "The payment couldn't be recorded. Please contact us.",
  "Erreur PayPal. Réessayez plus tard.": "PayPal error. Please try again later.",
  "Élève": "Student",
  "Élèves max": "Max students",
  "Étudiant": "Student",
  "élèves": "students",
  // Page d'accueil
  "Bienvenue !": "Welcome!",
  "Tatie Soso, c'est pour qui ?": "Who is Tatie Soso for?",
  "Rejoindre l'équipe": "Join the team",
  "Voir le profil": "View profile",
  "Un peu de tout": "A bit of everything",
  "Trouve la matière qui te fait envie et découvre les prochains cours.": "Pick the subject you fancy and discover the upcoming classes.",
  "L'équipe": "The team",
  "Simple comme bonjour": "Easy as pie",
  "Ils en parlent": "In their words",
  // Légal / RGPD
  "Documents légaux": "Legal documents",
  "Mentions légales": "Legal notice",
  "Conditions générales": "Terms and conditions",
  "Confidentialité": "Privacy",
  "Ce document n'existe pour l'instant qu'en français. La version française fait foi.": "This document is currently only available in French. The French version is legally binding.",
  "Je suis le parent ou le tuteur légal de cet enfant de moins de 13 ans, je crée ce compte pour lui et j'accepte les conditions en son nom.": "I am the parent or legal guardian of this child under 13, I am creating this account for them and I accept the terms on their behalf.",
  "J'ai moins de 18 ans et mon parent ou tuteur légal est d'accord pour que je m'inscrive et que j'utilise Tatie Soso.": "I am under 18 and my parent or legal guardian agrees to me signing up and using Tatie Soso.",
  "J'accepte les": "I accept the",
  "conditions générales": "terms and conditions",
  "et j'ai lu la": "and I have read the",
  "politique de confidentialité": "privacy policy",
  "En vous connectant, vous restez soumis·e aux": "By signing in, you remain bound by the",
  "et à la": "and the",
  "et je demande que le cours ait lieu à la date prévue. Je sais que je perds mon droit de rétractation de 14 jours une fois le cours donné.": "and I ask for the class to take place on the scheduled date. I understand that I lose my 14-day right of withdrawal once the class has been given.",
  "Accepte d'abord les conditions générales.": "Please accept the terms and conditions first.",
  "Tes pièces n'expirent pas. Celles que tu n'as pas utilisées te sont remboursées sur simple demande.": "Your coins never expire. Unused coins are refunded on request.",
  "En savoir plus": "Learn more",
  " et je commande {n} pièces pour {n} €, avec obligation de paiement. Je dispose de 14 jours pour me rétracter.": " and I order {n} coins for €{n}, with an obligation to pay. I have 14 days to withdraw.",
  "Un transfert confirmé est définitif : vérifie bien l'adresse e-mail du destinataire.": "A confirmed transfer is final: double-check the recipient's email address.",
  "Impossible de préparer tes données. Réessaie plus tard.": "Your data could not be prepared. Please try again later.",
  "Mes données personnelles": "My personal data",
  "Tu peux récupérer une copie de tes données ou demander la fermeture de ton compte.": "You can download a copy of your data or ask for your account to be closed.",
  "Politique de confidentialité": "Privacy policy",
  "Télécharger mes données": "Download my data",
  "Demander la suppression de mon compte": "Request account deletion",
  "Nos conditions évoluent": "Our terms are changing",
  "Pour continuer à utiliser Tatie Soso, merci de lire et d'accepter nos conditions générales et notre politique de confidentialité.": "To keep using Tatie Soso, please read and accept our terms and conditions and our privacy policy.",
  "Continuer": "Continue",
  "Devenir prof": "Become a teacher",
  "Informations": "Information",
  "Contact": "Contact",
  // Connexion par e-mail et serveur
  "Adresse e-mail": "Email address",
  "Adresse e-mail invalide.": "Invalid email address.",
  "Afficher le mot de passe": "Show password",
  "Au moins 8 caractères.": "At least 8 characters.",
  "C'est fait": "Done",
  "Ce paiement a déjà été enregistré.": "This payment has already been recorded.",
  "Cette adresse e-mail est déjà liée à une autre méthode de connexion (Google ou mot de passe).": "This email is already linked to another sign-in method (Google or password).",
  "Cette commande PayPal ne vous appartient pas.": "This PayPal order doesn't belong to you.",
  "Commande PayPal introuvable.": "PayPal order not found.",
  "Commande PayPal invalide.": "Invalid PayPal order.",
  "Confirme d'abord ton adresse e-mail (clique sur le lien reçu par e-mail).": "Please confirm your email address first (click the link in the email).",
  "Confirme ton adresse e-mail : clique sur le lien envoyé à {email} (regarde aussi dans les spams).": "Confirm your email address: click the link sent to {email} (check your spam folder too).",
  "Créer mon compte": "Create my account",
  "E-mail ou mot de passe incorrect.": "Incorrect email or password.",
  "E-mail renvoyé !": "Email sent again!",
  "Il manque quelques informations pour terminer ton inscription.": "A few details are missing to finish signing up.",
  "La connexion par e-mail n'est pas encore activée sur le site.": "Email sign-in isn't enabled on the site yet.",
  "Le paiement PayPal n'est pas encore configuré. Contactez-nous.": "PayPal payment isn't set up yet. Please contact us.",
  "Le serveur Tatie Soso ne répond pas. Réessayez dans un instant.": "The Tatie Soso server isn't responding. Please try again in a moment.",
  "Masquer le mot de passe": "Hide password",
  "Mot de passe": "Password",
  "Mot de passe oublié ?": "Forgot password?",
  "Mot de passe trop faible : au moins 8 caractères.": "Password too weak: at least 8 characters.",
  "Pas de connexion Internet. Vérifie ton réseau puis réessaie.": "No internet connection. Check your network and try again.",
  "Pas encore confirmé. Clique sur le lien dans l'e-mail, puis réessaie.": "Not confirmed yet. Click the link in the email, then try again.",
  "Renvoyer l'e-mail": "Resend email",
  "Réservé à l'administration.": "Admins only.",
  "Se connecter": "Log in",
  "Seul le professeur du cours peut le supprimer.": "Only the class's teacher can delete it.",
  "Seuls les paiements en euros sont acceptés.": "Only payments in euros are accepted.",
  "Si un compte existe avec cette adresse, un e-mail pour choisir un nouveau mot de passe vient d'être envoyé (pense à regarder dans les spams).": "If an account exists with this address, an email to choose a new password has just been sent (check your spam folder too).",
  "Solde invalide.": "Invalid balance.",
  "Terminer mon inscription": "Finish signing up",
  "Trop de tentatives. Patiente quelques minutes puis réessaie.": "Too many attempts. Wait a few minutes and try again.",
  "Un compte existe déjà avec cette adresse e-mail. Connecte-toi (ou utilise « Mot de passe oublié »).": "An account already exists with this email. Log in (or use “Forgot password”).",
  "ou": "or",
  "Écris d'abord ton adresse e-mail ci-dessus.": "Enter your email address above first.",
  "Bourse": "Stock market",
  "NB : la valeur réelle ne change jamais, 1 pièce = 1 €.": "NB: the real value never changes, 1 coin = €1.",
};

export default dict;
